import React from 'react';
import { useSelector } from 'react-redux';

import { getUserProfileTeamId } from 'selectors/user/user-profiles-selector';

import styles from '../profile.module.css';

type TeamsState = {
    entities?: { teams?: Record<number, { logo?: string | null; nameEn?: string | null } | undefined> };
};

/** The team of the user's profile, if it has one */
const TeamItem = () => {
    const teamId: number | null | undefined = useSelector(getUserProfileTeamId);
    const team = useSelector((state: TeamsState) => (teamId ? state.entities?.teams?.[teamId] : undefined));

    if (!team) {
        return null;
    }

    return (
        <div className={styles.teamItem}>
            <div className={styles.teamLogoContainer}>
                <img alt="" src={team.logo ?? undefined} className={styles.teamItemLogo} />
            </div>
            <div className={styles.teamName}>{team.nameEn}</div>
        </div>
    );
};

export default TeamItem;
